module.exports = __webpack_public_path__ + "img/Social_3.6f369d86.webp";